/**
 * @krisspy-file
 * @type layout
 * @name "AuthLayout"
 * @export "default"
 */

import React from 'react';
import {
  DEFAULT_LOGO_ALT,
  DEFAULT_LOGO_URL,
  getWhitelabelBranding,
} from '../lib/whitelabel';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  // On a whitelabel host the Click&Share logo is never shown.
  const whitelabel = getWhitelabelBranding();
  const logoUrl = whitelabel ? whitelabel.logoUrl : DEFAULT_LOGO_URL;
  const logoAlt = whitelabel ? whitelabel.name : DEFAULT_LOGO_ALT;

  return (
    <div className="min-h-screen bg-secondary flex items-center justify-center p-lg">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue/5 via-transparent to-blue/5" />

      {/* Content Container */}
      <div className="relative w-full max-w-md">
        {/* Logo/Brand Section */}
        <div className="text-center mb-xl">
          {logoUrl && (
            <div className="inline-flex items-center justify-center mb-lg">
              <img src={logoUrl} alt={logoAlt} className="h-24 w-auto" />
            </div>
          )}
          <p className="text-secondary text-sm">Admin Panel</p>
        </div>

        {/* Auth Card */}
        <div className="card shadow-xl">
          {children}
        </div>

        {/* Footer */}
        <div className="text-center mt-xl">
          <p className="text-secondary text-xs">
            © {new Date().getFullYear()} Rental Admin Panel. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}
